import { Component, OnInit } from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
@Component({
  selector: 'app-pulsing-tooltip',
  templateUrl: './pulsing-tooltip.component.html',
  styleUrls: ['./pulsing-tooltip.component.scss'],
  standalone: true,
  imports: [MaterialModule]
})
export class PulsingTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
